import styled from 'styled-components'

export const Calculator = styled.div`
  width: 100%;
  height: 100%;
`
